<div *ngIf="app.isLoggedIn; then loginBlock else elseBlock"></div>
<ng-template #loginBlock>
    <p-card [style]="{'max-width': '700px', 'margin': 'auto', 'margin-top': '30px'}">
        <p-tabView>
            <p-tabPanel header="My Info">
                <app-my-info [user]="user" (emitSave)="updateUserProfile($event)"></app-my-info>
            </p-tabPanel>

            <p-tabPanel header="Subscription">
                <app-subscription [user]="user"></app-subscription>
            </p-tabPanel>

            <p-tabPanel header="Integration">
                <app-integration [user]="user" (emitSave)="updateUserProfile($event)"></app-integration>
            </p-tabPanel>

            <p-tabPanel header="Bill & Usage">
                <app-bill-usage [user]="user"></app-bill-usage>
            </p-tabPanel>

            <p-tabPanel header="Streaming">
                <app-streaming [user]="user"></app-streaming>
            </p-tabPanel>
        </p-tabView>
    </p-card>
</ng-template>
<ng-template #elseBlock>
    <div class="home-component">
        <h1 class="p-text-center" style="color: #858585; margin-top: 100px;">
            Thank you to visit Save What Live Captions.
        </h1>
    </div>
</ng-template>